import { useCallback, useImperativeHandle, useState } from 'react';
export function useSingleAlwaysOpenAccordionController(ref, _a) {
    var defaultExpanded = _a.defaultExpanded, onPanelChanged = _a.onPanelChanged;
    var _b = useState(defaultExpanded), currentOpen = _b[0], setCurrentOpen = _b[1];
    var getIsOpen = useCallback(function (id) {
        return id === currentOpen;
    }, [currentOpen]);
    var setIsOpen = useCallback(function (id) {
        setCurrentOpen(id);
        onPanelChanged && onPanelChanged(id);
    }, [onPanelChanged]);
    useImperativeHandle(ref, function () { return ({
        open: function (id) {
            setCurrentOpen(id);
            onPanelChanged && onPanelChanged(id);
        },
        close: function () { },
        closeAll: function () { },
    }); }, [onPanelChanged]);
    return { getIsOpen: getIsOpen, setIsOpen: setIsOpen };
}
//# sourceMappingURL=useSingleAlwaysOpenAccordionController.js.map